import { jsx as r, jsxs as b } from "react/jsx-runtime";
import { Select as a, Row as w, Col as l, InputNumber as x } from "antd";
import { memo as j, useMemo as q, useCallback as d } from "react";
import { y as p, D as S } from "../../../../utils-wNl4DVdv.js";
import { u as v } from "../../../../styled-components.browser.esm-BFmoFexH.js";
import { useLanguageResolver as P } from "@biron-data/react-contexts";
const V = j(function({
  id: m,
  dayDifference: f,
  activated: h,
  value: s,
  onChange: e
}) {
  var y;
  const n = P(), g = q(
    () => Object.keys(p).map((i) => /* @__PURE__ */ r(
      a.OptGroup,
      {
        label: n.get(`growth.group.${i}`),
        children: p[i].map(
          ({ label: t }, o) => /* @__PURE__ */ r(
            a.Option,
            {
              value: t,
              children: n.get(`growth.preset.${t}`)
            },
            `${t}-${o}`
          )
        )
      },
      `${i}-groupName-${m}`
    )),
    [m, n]
  ), c = d((i) => Object.values(p).flat().find((t) => t.label === i), []), O = d(
    (i) => {
      const t = c(i), o = i === "previous" && (t != null && t.value.unit) && f !== void 0 ? {
        unit: t == null ? void 0 : t.value.unit,
        quantity: void 0
      } : t == null ? void 0 : t.value;
      o && (e == null || e({
        unit: o.unit,
        quantity: o.quantity
      }));
    },
    [c, f, e]
  ), $ = d((i) => {
    s && (e == null || e({
      ...s,
      quantity: i
    }));
  }, [e, s]), u = S(s);
  return /* @__PURE__ */ b(w, { children: [
    /* @__PURE__ */ r(l, { span: 17, children: /* @__PURE__ */ r(a, { style: { width: "100%" }, onChange: O, disabled: !h, virtual: !1, dropdownMatchSelectWidth: !1, value: u, children: g }) }),
    /* @__PURE__ */ r(l, { span: 7, children: u && ((y = c(u)) == null ? void 0 : y.preffix) && /* @__PURE__ */ b(w, { children: [
      /* @__PURE__ */ r(l, { span: 10, children: /* @__PURE__ */ r(G, { children: "-" }) }),
      /* @__PURE__ */ r(l, { span: 14, children: /* @__PURE__ */ r(x, { style: { maxWidth: "100%" }, min: 1, value: s == null ? void 0 : s.quantity, disabled: !h, onChange: (i) => {
        i && $(i);
      } }) })
    ] }) })
  ] });
}), G = v.div`
    display: flex;
    justify-content: center;
    height: 100%;
    align-items: center;
`;
export {
  V as default
};
//# sourceMappingURL=PeriodSelector.js.map
